// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__CDF7h","label":"Labeled_label__1u2zc","divider":"Labeled_divider__3eL-J"};